import * as React from 'react';
import styled from '@emotion/styled';
import { Link as RouterLink } from 'react-router';
import { headingTypography } from '../typography';

export const HomeSectionHeader: React.FC<{ id: string; title: string; to: string; linkLabel: string }> = ({
  id,
  title,
  to,
  linkLabel
}) => (
  <S.Header>
    <S.Title id={id}>{title}</S.Title>
    <S.Link to={to}>
      {linkLabel} <span aria-hidden="true">→</span>
    </S.Link>
  </S.Header>
);

namespace S {
  export const Header = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 22px;
  `;
  export const Title = styled.h2`
    ${(p) => headingTypography(p.theme)};
    font-size: clamp(28px, 3vw, 38px);
    margin: 0;
  `;
  export const Link = styled(RouterLink)`
    color: ${(p) => p.theme.text.special};
    font-size: 14px;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  `;
}
